export default "__VITE_ASSET__DHg5ERbE__"